import axiosInstance from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";

const headers = {
  ContentType: "application/json",
};

export const AuthAPI = {

  signIn: async function (user) {
    const response = await axiosInstance.request({
      url: `/auth/authenticate`,
      method: "POST",
      data: user,
      // timeout: 6000
    })
    return response.data
  },
  memberSignIn: async function (loginDetails) {
    const response = await axiosInstance.request({
      url: `/register/member-login`,
      method: "POST",
      data: loginDetails,
      // timeout: 6000

    })
    return response.data
  },

  postVerifyCaptcha: async function (token) {
    const response = await axiosInstance.request({
      url: `/auth/captcha-verify`,
      method: "POST",
      data: {
        token: token,
      },
      // timeout: 2000
    })
    return response.data
  },

  refreshToken: async function (refreshToken) {
    const response = axiosInstance.request({
      url: `/auth/refresh-token`,
      method: "POST",
      timeout: 2000,
      data: refreshToken,
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    return response.data
  },

  signOut: async function (signOutData) {
    const response = await axiosInstance.request({
      url: `/auth/signOut`,
      method: "POST",
      data: signOutData,
      timeout: 2000
    })
    return response.data
  },

  forgotPassword: async function (forgotPasswordData) {
    const response = await axiosInstance.request({
      url: `/auth/forgot-password`,
      method: "POST",
      data: forgotPasswordData,
      timeout: 2000
    });
    return response.data;
  },

  confirmResetPassword: async function (confirmResetpasswordData) {
    const response = await axiosInstance.request({
      url: `/auth/reset-password`,
      method: "POST",
      data: confirmResetpasswordData,
    });
    return response.data;
  },

  confirmSignUp: async function (confirmData) {
    const response = await axiosInstance.request({
      url: `/auth/confirmSignUp`,
      method: "POST",
      data: confirmData,
    });
    return response.data;
  },

  findEventAndClubByToken: async function (token) {
    const response = await axiosInstance.request({
      url: `/auth/check/token/${token}`,
      method: "POST",
      data: {}
    });
    return response.data;
  },
};